import { useEffect, useState } from 'react';

import { requestBookedVendors } from '~/actions/bookedVendorsActions';
import { fetchVendorTeam } from '~/actions/couples/vendorTeamActions';
import { error as errorNotification } from '~/actions/notificationActions';
import { useUserContext } from '~/contexts/UserContext';
import { AppDispatch, useAppDispatch, useAppSelector } from '~/reducers';
import { getVendorTeam } from '~/selectors/vendorTeamSelectors';
import Logger from '~/util/logger';

export const fetchVendorTeamFn = (dispatch: AppDispatch) => {
  dispatch(fetchVendorTeam()).catch((error: Error) => {
    Logger.error(error);
    dispatch(
      errorNotification({
        message: 'We could not retrieve your vendor list. Please try again.',
      })
    );
  });
};

const useVendorTeam = () => {
  const dispatch = useAppDispatch();
  const userContext = useUserContext();
  const { vendorTeamDashboard, loaded } = useAppSelector(getVendorTeam) || {};

  const [isGuest, setIsGuest] = useState(true);

  useEffect(() => {
    if (userContext && userContext.is_guest !== undefined) {
      setIsGuest(userContext.is_guest);
    }
  }, [userContext]);

  useEffect(() => {
    if (!isGuest) {
      dispatch(requestBookedVendors())
        .then(() => fetchVendorTeamFn(dispatch))
        .catch(() => null);
    }
  }, [isGuest, dispatch]);

  if (loaded) {
    return vendorTeamDashboard;
  }

  return [];
};

export default useVendorTeam;
